<div class="cart" [class.rtl]="!isEnglish" [class.ltr]="isEnglish">
  @if (loaded) {
  <div class="icon">
    <mat-icon [svgIcon]="icon" class="icon-lg"></mat-icon>
  </div>
  <div class="label">
    <span>{{ 'dashboard.' + label.firstLine | translate }}</span>
    <span>{{ 'dashboard.' + label.secondLine | translate }}</span>
  </div>
  <div class="count">
    {{ count | toArabic }}
  </div>
  } @else {
  <app-skeleton [type]="'card'"></app-skeleton>
  }
</div>
